<template>
  <div class="card d-print-none mb-2">
    <div class="card-body">
      <router-link :to="taskData.api_url" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" ><i class="feather icon-corner-up-left"></i> {{labels.get('label_back')}}</router-link>
    </div>
  </div>
  <div id="accordion" v-if="item.exists">
    <div class="card">
      <div class="card-header p-1">
        <a class="btn btn-sm" data-toggle="collapse" href="#label_basic_info">Basic Info</a>
      </div>
      <div id="label_basic_info" class="collapse show">
        <div class="row pl-3 pt-2">
          <div class="col-md-3">
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Part Number:</label></div>
              <div class="col-7">{{item.data.part_number}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Category:</label></div>
              <div class="col-7">{{item.data.category_code}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Type:</label></div>
              <div class="col-7">{{item.data.type_code}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Description:</label></div>
              <div class="col-7">{{item.data.description}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Additional Description:</label></div>
              <div class="col-7">{{item.data.description_additional}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Datasheet Done:</label></div>
              <div class="col-7">{{item.data.datasheet_done}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Make/Buy</label></div>
              <div class="col-7">{{item.data.make_buy}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Drawing Number</label></div>
              <div class="col-7">{{item.data.drawing_number}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Unit</label></div>
              <div class="col-7">{{item.data.unit}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Note</label></div>
              <div class="col-7">{{item.data.note}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 1:</label></div>
              <div class="col-7">{{item.data.vendor1_name}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 1 PN:</label></div>
              <div class="col-7">{{item.data.vendor1_pn}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 2:</label></div>
              <div class="col-7">{{item.data.vendor2_name}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 2 PN:</label></div>
              <div class="col-7">{{item.data.vendor2_pn}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 3:</label></div>
              <div class="col-7">{{item.data.vendor3_name}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 3 PN:</label></div>
              <div class="col-7">{{item.data.vendor3_pn}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Cost</label></div>
              <div class="col-7">{{item.data.cost}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Service Part</label></div>
              <div class="col-7">{{item.data.service_part}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Released</label></div>
              <div class="col-7">{{item.data.released}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Release Number</label></div>
              <div class="col-7">{{item.data.release_number}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-5"><label class="font-weight-bold float-right">Revision</label></div>
              <div class="col-7">{{item.data.revision_manual}}</div>
            </div>
          </div>
        </div>
        <div class="row pl-3" v-if="item.data.sub_pns_ordered.length>0">
          <div class="col-12"><label class="font-weight-bold">Sub Part Numbers:</label></div>
          <div class="col-12" style='overflow-x:auto;'>
            <table class="table table-bordered">
              <thead class="table-active">
              <tr>
                <th style="width: 110px;">Order Number</th>
                <th style="width: 110px;">Quantity</th>
                <th style="width: 250px;">Part Number</th>
                <th>Description</th>
                <th>Additional Description</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="pn in item.data.sub_pns_ordered">
                <tr :id="'tr_sub_pn_'+pn.id">
                  <td class="text-right">{{pn.order_number}}</td>
                  <td class="text-right">{{pn.quantity}}</td>
                  <td>{{ item.data.sub_pns_info[pn.id]['part_number'] }}</td>
                  <td>{{ item.data.sub_pns_info[pn.id]['description'] }}</td>
                  <td>{{ item.data.sub_pns_info[pn.id]['description_additional'] }}</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="item.data.history_manual.length>0">
      <div class="card-header p-1">
        <a class="btn btn-sm" data-toggle="collapse" href="#label_history_manual">Revision Histories </a>
      </div>
      <div id="label_history_manual" class="collapse">
        <template v-for="history in item.data.history_manual">
          <div class="card ml-3">
            <div class="card-header p-1">
              <a class="btn btn-sm" data-toggle="collapse" :href="'#label_history_manual_'+history.id">Revision {{history.revision_manual}}</a>
            </div>
            <div :id="'label_history_manual_'+history.id" class="collapse hide">
              <div class="row pl-3 pt-2">
                <div class="col-md-3">
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Part Number:</label></div>
                    <div class="col-7">{{history.part_number}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Category:</label></div>
                    <div class="col-7">{{history.category_code}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Type:</label></div>
                    <div class="col-7">{{history.type_code}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Description:</label></div>
                    <div class="col-7">{{history.description}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Additional Description:</label></div>
                    <div class="col-7">{{history.description_additional}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Created By:</label></div>
                    <div class="col-7">{{item.data.users_info[history.created_by]['name']}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Created Time:</label></div>
                    <div class="col-7">{{history.created_at}}</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Datasheet Done:</label></div>
                    <div class="col-7">{{history.datasheet_done}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Make/Buy</label></div>
                    <div class="col-7">{{history.make_buy}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Drawing Number</label></div>
                    <div class="col-7">{{history.drawing_number}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Unit</label></div>
                    <div class="col-7">{{history.unit}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Note</label></div>
                    <div class="col-7">{{history.note}}</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 1:</label></div>
                    <div class="col-7">{{history.vendor1_name}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 1 PN:</label></div>
                    <div class="col-7">{{history.vendor1_pn}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 2:</label></div>
                    <div class="col-7">{{history.vendor2_name}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 2 PN:</label></div>
                    <div class="col-7">{{history.vendor2_pn}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 3:</label></div>
                    <div class="col-7">{{history.vendor3_name}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 3 PN:</label></div>
                    <div class="col-7">{{history.vendor3_pn}}</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Cost</label></div>
                    <div class="col-7">{{history.cost}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Service Part</label></div>
                    <div class="col-7">{{history.service_part}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Released</label></div>
                    <div class="col-7">{{history.released}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Release Number</label></div>
                    <div class="col-7">{{history.release_number}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Revision</label></div>
                    <div class="col-7">{{history.revision_manual}}</div>
                  </div>
                </div>
              </div>
              <div class="row pl-3" v-if="history.sub_pns_ordered.length>0">
                <div class="col-12"><label class="font-weight-bold">Sub Part Numbers:</label></div>
                <div class="col-12" style='overflow-x:auto;'>
                  <table class="table table-bordered">
                    <thead class="table-active">
                    <tr>
                      <th style="width: 110px;">Order Number</th>
                      <th style="width: 110px;">Quantity</th>
                      <th style="width: 250px;">Part Number</th>
                      <th>Description</th>
                      <th>Additional Description</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="pn in history.sub_pns_ordered">
                      <tr>
                        <td class="text-right">{{pn.order_number}}</td>
                        <td class="text-right">{{pn.quantity}}</td>
                        <td>{{ item.data.sub_pns_info[pn.id]['part_number'] }}</td>
                        <td>{{ item.data.sub_pns_info[pn.id]['description'] }}</td>
                        <td>{{ item.data.sub_pns_info[pn.id]['description_additional'] }}</td>
                      </tr>
                    </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </template>

      </div>
    </div>
    <div class="card" v-if="item.data.history.length>0">
      <div class="card-header p-1">
        <a class="btn btn-sm" data-toggle="collapse" href="#label_history">Edit Histories </a>
      </div>
      <div id="label_history" class="collapse">
        <template v-for="history in item.data.history">
          <div class="card ml-3">
            <div class="card-header p-1">
              <a class="btn btn-sm" data-toggle="collapse" :href="'#label_history_'+history.id">History {{history.revision}}</a>
            </div>
            <div :id="'label_history_'+history.id" class="collapse hide">
              <div class="row pl-3 pt-2">
                <div class="col-md-3">
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Part Number:</label></div>
                    <div class="col-7">{{history.part_number}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Category:</label></div>
                    <div class="col-7">{{history.category_code}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Type:</label></div>
                    <div class="col-7">{{history.type_code}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Description:</label></div>
                    <div class="col-7">{{history.description}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Additional Description:</label></div>
                    <div class="col-7">{{history.description_additional}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Created By:</label></div>
                    <div class="col-7">{{item.data.users_info[history.created_by]['name']}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Created Time:</label></div>
                    <div class="col-7">{{history.created_at}}</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Datasheet Done:</label></div>
                    <div class="col-7">{{history.datasheet_done}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Make/Buy</label></div>
                    <div class="col-7">{{history.make_buy}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Drawing Number</label></div>
                    <div class="col-7">{{history.drawing_number}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Unit</label></div>
                    <div class="col-7">{{history.unit}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Note</label></div>
                    <div class="col-7">{{history.note}}</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 1:</label></div>
                    <div class="col-7">{{history.vendor1_name}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 1 PN:</label></div>
                    <div class="col-7">{{history.vendor1_pn}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 2:</label></div>
                    <div class="col-7">{{history.vendor2_name}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 2 PN:</label></div>
                    <div class="col-7">{{history.vendor2_pn}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 3:</label></div>
                    <div class="col-7">{{history.vendor3_name}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 3 PN:</label></div>
                    <div class="col-7">{{history.vendor3_pn}}</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Cost</label></div>
                    <div class="col-7">{{history.cost}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Service Part</label></div>
                    <div class="col-7">{{history.service_part}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Released</label></div>
                    <div class="col-7">{{history.released}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Release Number</label></div>
                    <div class="col-7">{{history.release_number}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="font-weight-bold float-right">Revision</label></div>
                    <div class="col-7">{{history.revision_manual}}</div>
                  </div>
                </div>
              </div>
              <div class="row pl-3" v-if="history.sub_pns_ordered.length>0">
                <div class="col-12"><label class="font-weight-bold">Sub Part Numbers:</label></div>
                <div class="col-12" style='overflow-x:auto;'>
                  <table class="table table-bordered">
                    <thead class="table-active">
                    <tr>
                      <th style="width: 110px;">Order Number</th>
                      <th style="width: 110px;">Quantity</th>
                      <th style="width: 250px;">Part Number</th>
                      <th>Description</th>
                      <th>Additional Description</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="pn in history.sub_pns_ordered">
                      <tr>
                        <td class="text-right">{{pn.order_number}}</td>
                        <td class="text-right">{{pn.quantity}}</td>
                        <td>{{ item.data.sub_pns_info[pn.id]['part_number'] }}</td>
                        <td>{{ item.data.sub_pns_info[pn.id]['description'] }}</td>
                        <td>{{ item.data.sub_pns_info[pn.id]['description_additional'] }}</td>
                      </tr>
                    </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </template>

      </div>
    </div>
  </div>
</template>
<script setup>


  import toastFunctions from "@/assets/toastFunctions";
  import labels from '@/labels'
  
  import {useRouter} from "vue-router";
  import {inject, reactive} from "vue";
  import axios from "axios";
  import DetailTemplate from '@/components/DetailTemplate.vue';
  import {useRoute} from "vue-router/dist/vue-router";
  import systemFunctions from "@/assets/systemFunctions";


  const route =useRoute()
  const router =useRouter()
  let taskData = inject('taskData')
  let item=reactive({
    id:0,
    exists:false,
    data:{
    }
  })
  const getItem=async ()=>{
    await axios.get(taskData.api_url+'/get-item-history/'+ item.id).then((res)=>{
      if (res.data.error == "") {
        item.data=res.data.item;
        item.exists=true;
      }
      else{
        toastFunctions.showResponseError(res.data)
      }
    });
  }
  item.id=route.params['item_id'];
  getItem();

</script>